<template>
    <div>
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    label="N° CNS"
                    v-model="model.cns"
                    v-mask="mask.cns"
                    :validations="validations.cns"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row class="flex-nowrap">
            <rkm-col>
                <rkm-form-input
                    label="CPF"
                    v-model="model.cpf"
                    v-mask="mask.cpf"
                    :validations="validations.cpf"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox v-model="model.cpfNaoPertenceAoCidadao">
                                CPF não pertence ao cidadão
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="5">
                <rkm-form-select
                    label="Motivo"
                    :options="form.motivosDuplicidadeCpf"
                    value-field="id"
                    text-field="descricao"
                    v-model="model.motivoDuplicidadeCpfId"
                    :validations="validations.motivoDuplicidadeCpf"
                    :disabled="!model.cpfNaoPertenceAoCidadao"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="isRequiredMotivoDuplicidadeCpfOutro">
            <rkm-col>
                <rkm-form-input
                    uppercase
                    label="Outro (Motivo)"
                    v-model="model.motivoDuplicidadeCpfOutro"
                    :validations="validations.motivoDuplicidadeCpfOutro"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    uppercase
                    label="Nome"
                    v-model="model.nome"
                    :validations="validations.nome"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="8">
                <rkm-form-input
                    uppercase
                    label="Nome social"
                    v-model="model.nomeSocial"
                    :validations="validations.nomeSocial"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    label="Prefere ser chamado pelo"
                    v-model="model.preferenciaNomeId"
                    :validations="validations.preferenciaNome"
                    value-field="id"
                    text-field="descricao"
                    :disabled="disablePreferenciaNome"
                    :options="form.preferenciasNome"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-date-picker
                    :validations="validations.dataNascimento"
                    :max-date="dataAtual"
                    label="Data de nascimento"
                    v-model="model.dataNascimento"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-date-picker
                    label="Data de óbito"
                    v-model="model.dataObito"
                    disabled
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    label="Sexo"
                    v-model="model.sexoId"
                    :validations="validations.sexo"
                    value-field="id"
                    text-field="descricao"
                    :options="form.sexos"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    label="Identidade de gênero"
                    v-model="model.identidadeGeneroId"
                    :validations="validations.identidadeGenero"
                    value-field="id"
                    text-field="descricao"
                    :options="form.identidadesGenero"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    label="Estado civil"
                    v-model="model.estadoCivilId"
                    value-field="id"
                    text-field="descricao"
                    :options="form.estadosCivis"
                    :validations="validations.estadoCivil"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="8">
                <rkm-form-input
                    label="Cônjuge"
                    uppercase
                    v-model="model.conjuge"
                    :validations="validations.conjuge"
                    :disabled="!isMarried"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    label="Situação familiar/conjugal"
                    v-model="model.situacaoFamiliarConjugalId"
                    value-field="id"
                    text-field="descricao"
                    :options="form.situacoesFamiliaresConjugais"
                    :validations="validations.situacaoFamiliarConjugal"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    uppercase
                    label="Nome da mãe"
                    v-model="model.nomeMae"
                    :validations="validations.nomeMae"
                    :disabled="model.desconheceNomeMae"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox v-model="model.desconheceNomeMae">
                                Desconhece
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    uppercase
                    label="Nome do pai"
                    v-model="model.nomePai"
                    :validations="validations.nomePai"
                    :disabled="model.desconheceNomePai"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox v-model="model.desconheceNomePai">
                                Desconhece
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    label="Local de nascimento"
                    v-model="model.localNascimentoId"
                    :validations="validations.localNascimento"
                    value-field="id"
                    text-field="descricao"
                    :options="form.locaisNascimento"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="5">
                <rkm-form-select
                    label="País de nascimento"
                    v-model="model.paisNascimentoId"
                    :validations="validations.paisNascimento"
                    value-field="id"
                    text-field="nome"
                    :disabled="isNotEstrangeiro"
                    :options="paises"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    label="Nacionalidade"
                    v-model="model.nacionalidadeId"
                    :validations="validations.nacionalidade"
                    value-field="id"
                    text-field="descricao"
                    :disabled="isNotEstrangeiro"
                    :options="nacionalidades"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-date-picker
                    :validations="validations.dataNaturalizacao"
                    :min-date="getDataNascimentoString()"
                    :max-date="dataAtual"
                    label="Data de naturalização"
                    v-model="model.dataNaturalizacao"
                    :disabled="!isNaturalizadoBrasileiro"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Portaria de naturalização"
                    v-model="model.portariaNaturalizacao"
                    :validations="validations.portariaNaturalizacao"
                    :disabled="!isNaturalizadoBrasileiro"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-select
                    label="Estado de nascimento"
                    v-model="model.estadoNascimentoId"
                    :validations="validations.estadoNascimento"
                    value-field="id"
                    text-field="uf"
                    :disabled="disableEstadoNascimento"
                    :options="localForm.estados"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input-autocomplete
                    :searchFields="localForm.autocompleteFields.municipioNascimento"
                    :repository="repositories.municipio"
                    :requestQueryStringParams="{ estado_id: model.estadoNascimentoId, not_municipio_id: cliente.municipio.id }"
                    v-model="model.municipioNascimento"
                    :validations="validations.municipioNascimento"
                    label="Município de nascimento"
                    :disabled="disableMunicipioNascimento"
                    uppercase
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-select
                    label="Raça/cor"
                    v-model="model.racaCorId"
                    :validations="validations.racaCor"
                    value-field="id"
                    text-field="descricao"
                    :options="form.racasCores"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Etnia indígena"
                    v-model="model.etniaIndigenaId"
                    :validations="validations.etniaIndigena"
                    value-field="id"
                    text-field="descricao"
                    :disabled="!isRequiredEtniaIndigena"
                    :options="form.etniasIndigenas"
                    show-default-option
                    :default-option-text="isRequiredEtniaIndigena ? 'Selecione' : 'Não se aplica'"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    label="Tipo sanguíneo"
                    v-model="model.tipoSanguineoId"
                    value-field="id"
                    text-field="descricao"
                    :options="form.tiposSanguineo"
                    :validations="validations.tipoSanguineo"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    label="Pessoa com deficiência (PcD)"
                    v-model="model.deficienciaId"
                    value-field="id"
                    text-field="descricao"
                    :options="form.deficiencias"
                    :validations="validations.deficiencia"
                    show-default-option
                />
            </rkm-col>

            <rkm-col cols="5">
                <rkm-form-input
                    uppercase
                    label="Outra (PcD)"
                    v-model="model.deficienciaOutro"
                    :validations="validations.deficienciaOutro"
                    :disabled="!isRequiredDeficienciaOutro"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    label="Mobilidade reduzida"
                    v-model="model.mobilidadeReduzidaId"
                    value-field="id"
                    text-field="descricao"
                    :options="form.mobilidadesReduzidas"
                    :validations="validations.mobilidadeReduzida"
                    show-default-option
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-select
                    label="Escolaridade"
                    v-model="model.escolaridadeId"
                    value-field="id"
                    text-field="descricao"
                    :options="form.escolaridades"
                    :validations="validations.escolaridade"
                    show-default-option
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            <rkm-form-checkbox v-model="model.frequentaEscola">
                                Frequenta escola
                            </rkm-form-checkbox>
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-select>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Moment.
import moment from 'moment'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Mixins.
import { error, repository, mask, data } from '@/mixins'

// Enuns.
import nacionalidade from '@/enums/cadastro/cidadao/nacionalidade'
import racaCor from '@/enums/cadastro/cidadao/racaCor'
import deficiencia from '@/enums/cadastro/cidadao/deficiencia'
import localNascimento from '@/enums/cadastro/cidadao/localNascimento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import estadoCivil from '@/enums/cadastro/cidadao/estadoCivil'
import motivoDuplicidadeCpf from '@/enums/cadastro/cidadao/motivoDuplicidadeCpf'
import pais from '@/enums/cadastro/localizacao/pais'

export default {
    mixins: [ error, repository, mask, data ],
    props: {
        termosInvalidos: { type: Array, required: true },
        dataAtual: { type: String, required: true },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        repositories: {
            estado: null,
            municipio: null,
        },
        enums: {
            nacionalidade,
            racaCor,
            deficiencia,
            localNascimento,
            preferenciaNome,
            estadoCivil,
            motivoDuplicidadeCpf,
            pais,
        },
        localForm: {
            estados: [],
            autocompleteFields: {
                municipioNascimento: [
                    { key: 'nome', searchable: true },
                ],
            },
        }
    }),
    watch: {
        'model.cpfNaoPertenceAoCidadao': function (naoPertence) {

            if (!naoPertence) {

                this.model.motivoDuplicidadeCpfId = null
            }
        },
        'model.motivoDuplicidadeCpfId': function (id) {

            if (id !== this.enums.motivoDuplicidadeCpf.OUTRO) {

                this.model.motivoDuplicidadeCpfOutro = ''
            }
        },
        'model.dataNascimento': function (data) {

            if (!data) return

            if (this.model.dataNaturalizacao && this.model.dataNaturalizacao < data) {

                this.model.dataNaturalizacao = null
            }

            if (this.model.dataEntradaDomicilio && this.model.dataEntradaDomicilio < data) {

                this.model.dataEntradaDomicilio = null
            }
        },
        'model.desconheceNomeMae': function (desconhece) {

            if (desconhece) {

                this.model.nomeMae = ''
            }
        },
        'model.desconheceNomePai': function (desconhece) {

            if (desconhece) {

                this.model.nomePai = ''
            }
        },
        'model.localNascimentoId': function (localNascimentoId) {

            if (!localNascimentoId) {

                this.model.paisNascimentoId = null
                this.model.nacionalidadeId = null
                this.model.documentos.estrangeiroEntradaBrasil.rne = ''

                return
            }

            if (this.localNascimentoOutroPais) {

                this.model.paisNascimentoId = null
                this.model.nacionalidadeId = this.enums.nacionalidade.ESTRANGEIRO
            }
            else if (this.localNascimentoNesteMunicipio || this.localNascimentoOutroMunicipio) {

                this.model.paisNascimentoId = this.enums.pais.BRASIL
                this.model.documentos.estrangeiroEntradaBrasil.rne = ''

                this.$nextTick(() => {

                    if (this.localNascimentoNesteMunicipio) {

                        this.model.estadoNascimentoId = this.cliente.municipio.estado.id

                        this.$nextTick(() => this.model.municipioNascimento = this.cliente.municipio)
                    } else {

                        this.model.estadoNascimentoId = null

                        this.$nextTick(() => this.model.municipioNascimento = null)
                    }
                })
            }
        },
        'model.paisNascimentoId': function (id) {

            this.model.estadoNascimentoId = null

            if (id) {

                if (id === this.enums.pais.BRASIL) {

                    this.model.nacionalidadeId = this.enums.nacionalidade.BRASILEIRO
                }

                this.setLoading()

                this.repositories.estado.index({ pais_id: id })
                    .then(({ data }) => this.localForm.estados = data)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
            else {

                this.localForm.estados = []
            }
        },
        'model.nacionalidadeId': function (id) {

            if (id !== this.enums.nacionalidade.NATURALIZADO_BRASILEIRO) {

                this.model.dataNaturalizacao = null
            }
        },
        'model.estadoNascimentoId': function () {

            this.model.municipioNascimento = null
        },
        isRequiredEtniaIndigena(required) {

            if (!required) {

                this.model.etniaIndigenaId = null
            }
        },
        isRequiredDeficienciaOutro(required) {

            if (!required) {

                this.model.deficienciaOutro = ''
            }
        },
        isMarried(married) {

            if (!married) {

                this.model.conjuge = ''
            }
        },
        disablePreferenciaNome(disable) {

            if (disable) {

                this.model.preferenciaNomeId = this.enums.preferenciaNome.NOME
            }
        },
    },
    computed: {
        ...mapGetters({ cliente: 'getCliente' }),
        validations() {
            return {
                cns: {
                    required: true,
                    min_max_without_mask: 15,
                    cns: true,
                },
                cpf: {
                    required: true,
                    min_max_without_mask: 11,
                    cpf: true
                },
                motivoDuplicidadeCpf: {
                    required: this.model.cpfNaoPertenceAoCidadao
                },
                motivoDuplicidadeCpfOutro: {
                    required: this.isRequiredMotivoDuplicidadeCpfOutro,
                    min: 3,
                    max: 50,
                },
                nome: {
                    required: true,
                    min: 6,
                    max: 150,
                    termo_invalido: this.termosInvalidos,
                    name: true,
                },
                nomeSocial: {
                    min: 3,
                    max: 150,
                    termo_invalido: this.termosInvalidos,
                },
                preferenciaNome: {},
                dataNascimento: {
                    required: true
                },
                sexo: {
                    required: true
                },
                identidadeGenero: {},
                estadoCivil: {},
                conjuge: {
                    required: this.isMarried,
                    min: 8,
                    max: 150,
                    name: true,
                },
                situacaoFamiliarConjugal: {},
                racaCor: {
                    required: true
                },
                etniaIndigena: {
                    required: this.isRequiredEtniaIndigena
                },
                tipoSanguineo: {},
                deficiencia: {},
                deficienciaOutro: {
                    required: this.isRequiredDeficienciaOutro,
                    min: 3,
                    max: 50,
                },
                mobilidadeReduzida: {},
                nomeMae: {
                    required: !this.model.desconheceNomeMae,
                    min: 8,
                    max: 150,
                    termo_invalido: this.termosInvalidos,
                    name: true,
                },
                nomePai: {
                    required: !this.model.desconheceNomePai,
                    min: 8,
                    max: 150,
                    termo_invalido: this.termosInvalidos,
                    name: true,
                },
                localNascimento: {
                    required: true,
                },
                paisNascimento: {
                    required: true
                },
                nacionalidade: {
                    required: true
                },
                dataNaturalizacao: {
                    required: true,
                },
                portariaNaturalizacao: {
                    required: true,
                    min: 16,
                    max: 16,
                },
                estadoNascimento: {
                    required: !this.localNascimentoOutroPais
                },
                municipioNascimento: {
                    required: !this.localNascimentoOutroPais
                },
                escolaridade: {},
            }
        },
        isRequiredEtniaIndigena() {

            return this.model.racaCorId === this.enums.racaCor.INDIGENA
                && this.model.nacionalidadeId === this.enums.nacionalidade.BRASILEIRO
        },
        isRequiredMotivoDuplicidadeCpfOutro() {

            return this.model.motivoDuplicidadeCpfId === this.enums.motivoDuplicidadeCpf.OUTRO
        },
        isRequiredDeficienciaOutro() {

            return this.model.deficienciaId === this.enums.deficiencia.OUTRO
        },
        localNascimentoNesteMunicipio() {

            return this.model.localNascimentoId === this.enums.localNascimento.NESTE_MUNICIPIO
        },
        localNascimentoOutroMunicipio() {

            return this.model.localNascimentoId === this.enums.localNascimento.OUTRO_MUNICIPIO
        },
        localNascimentoOutroPais() {

            return this.model.localNascimentoId === this.enums.localNascimento.OUTRO_PAIS
        },
        disableEstadoNascimento() {

            return !this.model.paisNascimentoId
                || !this.model.localNascimentoId
                || !this.isPaisNascimentoBrasil
                || this.localNascimentoNesteMunicipio
        },
        disableMunicipioNascimento() {

            return !this.model.estadoNascimentoId
                || !this.model.localNascimentoId
                || this.localNascimentoNesteMunicipio
        },
        isNotEstrangeiro() {

            return !this.model.localNascimentoId
                || this.localNascimentoNesteMunicipio
                || this.localNascimentoOutroMunicipio
        },
        isMarried() {

            return this.model.estadoCivilId === this.enums.estadoCivil.CASADO
        },
        isNaturalizadoBrasileiro() {

            return this.model.nacionalidadeId == this.enums.nacionalidade.NATURALIZADO_BRASILEIRO
        },
        disablePreferenciaNome() {

            return this.isNullOrEmptyString(this.model.nome)
                || this.isNullOrEmptyString(this.model.nomeSocial)
        },
        paises() {

            if (this.localNascimentoOutroPais) {

                return this.form.paises.filter(p => p.id !== this.enums.pais.BRASIL)
            }

            return this.form.paises
        },
        nacionalidades() {

            if (this.localNascimentoOutroPais) {

                return this.form.nacionalidades.filter(n => n.id !== this.enums.nacionalidade.BRASILEIRO)
            }

            return this.form.nacionalidades
        },
        isPaisNascimentoBrasil() {
            return this.model.paisNascimentoId === this.enums.pais.BRASIL
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getDataNascimentoString() {

            return this.model.dataNascimento
                ? moment(this.model.dataNascimento).format('DD/MM/YYYY')
                : null
        },
    },
    created() {

        this.repositories.estado = this.getConectaSusRepository('intranet.estado')
        this.repositories.municipio = this.getConectaSusRepository('intranet.municipio')

        this.model.preferenciaNomeId = this.enums.preferenciaNome.NOME
    }
}
</script>